<template>
  <div class="image-circle" :style="style" :class="colorClass">
    <div class="image-circle-text"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    diameter: {
      type: String,
      default: '30px'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      let s = `width:${this.diameter};height:${this.diameter};`
      // fix font causing not vertical centered
      s += `line-height: ${this.diameter};`
      return s
    },
    colorClass () {
      if (this.disabled) {
        return 'disabled'
      }
      return 'active'
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.image-circle {
  position: relative;
  text-align: center;
  border-radius: 100px;
  color: var(--colorWhite);

  &.active {
    background-color: var(--colorMain);
  }
  &.disabled {
    background-color: var(--colorGray3);
  }

  & .image-circle-text {
    display: inline-block;
    @media (--mediaPc) {
      font-size: var(--textSize2);
    }
    @media (--mediaMobile) {
      font-size: var(--textSize2Mobile);
    }
  }

  &::before {
    content: '';
    width: 0;
    height: 100%;
    display: inline-block;
    position: relative;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/image/NumberCircle.vue